import { getBaseUrl } from '../../maps/apiEnvironmentMap';
import { LockerPosition, PackageCandidate } from '../microservices';

const API_KEY = process.env.REACT_APP_API_KEY;
export class IncidentRequestPOST {
  readonly method: string = 'operation/incidents';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}`;
  }

  public generateContent(
    packageCandidateId: number,
    lockerPositionId: number,
    incidentId: number
  ) {
    const params = {
      packageCandidateId: packageCandidateId,
      lockerPositionId: lockerPositionId,
      incidentId: incidentId,
    };
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    };
  }
}
export type IncidentResponsePOST = {
  status: string;
  message: string;
  data: {
    message: string;
    errors: any;
    packageCandidate: PackageCandidate;
    lockerPosition?: LockerPosition;
  };
};
